var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingcart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.1421 4.00014L6.00913 16.1358C6.02271 16.236 6.05113 16.3314 6.0921 16.4199C6.21543 16.6862 6.45246 16.8891 6.74088 16.9662C6.82899 16.9899 6.92133 17.0017 7.01578 17.0001H18C18.4416 17.0001 18.8309 16.7105 18.9578 16.2875L21.9578 6.28749C22.0487 5.98471 21.991 5.65682 21.8023 5.40321C21.6136 5.1496 21.3161 5.00014 21 5.00014H6.31948L5.99058 2.86233C5.97826 2.77295 5.95413 2.68733 5.91981 2.60712C5.85751 2.46104 5.76213 2.33451 5.64429 2.23533C5.53497 2.14314 5.40561 2.07396 5.26367 2.03526C5.17434 2.0108 5.0806 1.99855 4.9847 2.00014H3C2.44772 2.00014 2 2.44785 2 3.00014C2 3.55242 2.44772 4.00014 3 4.00014H4.1421ZM7.85794 15.0001L6.62717 7.00014H19.656L17.256 15.0001H7.85794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20.0001C10 21.1047 9.10457 22.0001 8 22.0001C6.89543 22.0001 6 21.1047 6 20.0001C6 18.8956 6.89543 18.0001 8 18.0001C9.10457 18.0001 10 18.8956 10 20.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 20.0001C19 21.1047 18.1046 22.0001 17 22.0001C15.8954 22.0001 15 21.1047 15 20.0001C15 18.8956 15.8954 18.0001 17 18.0001C18.1046 18.0001 19 18.8956 19 20.0001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingcart);
export default __webpack_public_path__ + "static/media/shoppingcart.b366a11142dd01d331c44951edcf82de.svg";
export { ForwardRef as ReactComponent };